import { Controller } from "@hotwired/stimulus"
import { Chart } from 'chart.js/auto';

Chart.defaults.font.size = 14;
Chart.defaults.font.family = "Manrope";
Chart.defaults.color = "#000000";

export default class extends Controller {
  static values = {
    data: Array,
    labels: Array
  }

  connect() {
    const data = this.dataValue;
    const labels = this.labelsValue;

    if (!data || !labels) {
      console.warn("No data data found");
      return;
    }

    const canvas = this.element;
    const ctx = canvas.getContext("2d");
    this.chart = new Chart(ctx, this.config(labels, data));
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
